import { KeyboardKeyEnum } from '@/React/Shared/Type/KeyboardKeyEnum'
import type { ComponentPropsWithRef, ReactNode } from 'react'

export interface ButtonSquareIconProps extends ComponentPropsWithRef<'div'> {
    children?: ReactNode
}

export function ButtonSquareIcon({
    children,
    className = '',
    onClick,
    onKeyDown,
    ...restProps
}: ButtonSquareIconProps) {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        onKeyDown?.(e)

        if (
            (e.key === KeyboardKeyEnum.Enter ||
                e.key === KeyboardKeyEnum.Space) &&
            onClick
        ) {
            e.preventDefault()
            onClick(e as any)
        }
    }

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            {...restProps}
            className={`cursor-pointer text-xl p-2 bg-gray-100 rounded-lg2 text-gray-400 hover:text-gray-900 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary focus-visible:outline-none ${className}`.trim()}
        >
            {children}
        </div>
    )
}
